import type { Network, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import { getCurrentNetworkId } from '../session/selectors';

export const findById = createFindById('networks');
export const findByIdThrows = createFindByIdThrows('networks');

type GetCurrentNetwork = (state: YammerState) => Network;
export const getCurrentNetwork: GetCurrentNetwork = (state) => {
  const currentNetworkId = getCurrentNetworkId(state);

  return findByIdThrows(state, currentNetworkId);
};

type GetFulfilledNetworks = (state: YammerState) => Record<string, Network>;
export const getFulfilledNetworks: GetFulfilledNetworks = (state) => state.networks.fulfilled.byId;

type GetNetworkPermalinkById = (state: YammerState, networkId: Network['id']) => Network['permalink'] | undefined;
export const getNetworkPermalinkById: GetNetworkPermalinkById = (state, networkId) => {
  const network = findById(state, networkId);

  return network?.permalink;
};
